import { useTranslation } from "react-i18next";
import {
  normalizeAppLanguage,
  type AppLanguage,
} from "@/lib/app-language";

/** Resolved UI language (en | de), stable across en / en-US style codes. */
export function useAppLanguage(): AppLanguage {
  const { i18n } = useTranslation();
  return normalizeAppLanguage(i18n.resolvedLanguage ?? i18n.language);
}
